import mixpanel from 'mixpanel-browser';

import { getFlag } from 'utils/launchDarklyClient';

import { getMixpanelConfig } from './mixpanel-config';

const isProduction = process.env.VITE_DEPLOY_ENV === 'production';

const MX_DEV = '5ce164a570f20c83bf648b03e2a7c062';
const MX_PROD = '8df242d1031d1bcc3c4d9143ed68a4aa';

const token = isProduction ? MX_PROD : MX_DEV;

let mixpanelInitialized = false;

export async function initMixpanel() {
  if (mixpanelInitialized) {
    return;
  }
  mixpanelInitialized = true;
  const useProxy = await getFlag('hasBlockedClientsProxy');
  mixpanel.init(token, getMixpanelConfig(useProxy));
}
